/**
 * The complete set of authenticated routes rendered inside MemberLayout.
 *
 * Native pages are standard by default: MemberLayout owns both status-bar and
 * fixed-navigation clearance. The two immersive, heavily customised primary
 * pages remain explicit exceptions so a new route can never silently acquire a
 * third layout contract.
 */
export const MEMBER_NATIVE_ROUTE_LAYOUTS = [
  ['dashboard', 'MemberDashboardPage'],
  ['book-facilities', 'MemberFacilitiesPage'],
  ['lets-play', 'MemberLetsPlayPage'],
  ['lets-play/:sportSlug', 'MemberLetsPlayPage'],
  ['developer-diagnostics', 'MemberDiagnosticsPage'],
  ['voting', 'MemberVotingListPage'],
  ['voting/:motionId', 'MemberVotingDetailPage'],
  ['activities', 'MemberActivitiesPage'],
  ['activities/:activityId', 'MemberActivityDetailPage'],
  ['manage', 'MemberManageActivitiesPage'],
  ['manage/activities/:activityId', 'MemberManageActivityDetailPage'],
  ['book-racquet/:sportType', 'MemberRacquetBookingPage'],
  ['book-racquet/:sportType/open-match/:bookingId/manage', 'MemberRacquetBookingPage'],
  ['book-racquet/:sportType/book', 'MemberRacquetBookingConfirmPage'],
  ['book-racquet/:sportType/booking/success', 'MemberRacquetBookingSuccessPage'],
  ['golf', 'MemberGolfLandingPage'],
  ['golf/:courseId', 'MemberGolfCoursePage'],
  ['golf/:courseId/rates', 'MemberGolfCourseRatesPage'],
  ['golf/:courseId/open-groups', 'MemberOpenGroupsPage'],
  ['golf/:courseId/book/:teeTimeId', 'MemberTeeBookingPage'],
  ['golf/booking/success', 'MemberGolfBookingSuccessPage'],
  ['fitness', 'MemberFitnessClassesPage'],
  ['fitness/:classId', 'MemberFitnessClassAvailabilityPage'],
  ['fitness/:classId/book', 'MemberFitnessBookingPage'],
  ['fitness/booking/success', 'MemberFitnessBookingSuccessPage'],
  ['spa', 'MemberSpaServicesPage'],
  ['spa/:serviceId', 'MemberSpaServiceAvailabilityPage'],
  ['spa/:serviceId/confirm', 'MemberSpaBookingConfirmPage'],
  ['spa/booking/success', 'MemberSpaBookingSuccessPage'],
  ['account', 'MemberAccountPage'],
  ['payment-received', 'MemberPrivanaPayResultPage'],
  ['payment-cancelled', 'MemberPrivanaPayResultPage'],
  ['payment-declined', 'MemberPrivanaPayResultPage'],
  ['profile', 'MemberProfilePage', 'special_profile'],
  ['events', 'MemberEventsPage'],
  ['dining', 'MemberDiningReservationsPage', 'special_dining'],
  ['reciprocal-clubs', 'MemberReciprocalClubsPage'],
  ['reciprocal-clubs/request/success', 'MemberReciprocalGuestPassRequestSuccessPage'],
  ['accommodations', 'MemberAccommodationsPage'],
  ['accommodations/book', 'MemberAccommodationBookingPage'],
  ['services', 'MemberServicesPage'],
  ['contact-front-desk', 'MemberContactFrontDeskPage'],
].map(([route, component, mode = 'standard']) => ({ route, component, mode }))

function routeMatches(pattern, route) {
  const expected = pattern.split('/')
  const actual = route.split('/')
  return expected.length === actual.length && expected.every((part, index) => (
    part.startsWith(':') || part === actual[index]
  ))
}

export function getMemberMobileLayout(pathname, clubCode) {
  const normalized = pathname.replace(/[?#].*$/, '').replace(/^\/+|\/+$/g, '')
  const prefix = `${clubCode}/`
  const memberRoute = normalized.startsWith(prefix) ? normalized.slice(prefix.length) : normalized
  return MEMBER_NATIVE_ROUTE_LAYOUTS.find(({ route }) => routeMatches(route, memberRoute)) || null
}

export function getMemberMobileLayoutMode(pathname, clubCode) {
  return getMemberMobileLayout(pathname, clubCode)?.mode || 'standard'
}
